export default __webpack_public_path__ + "static/hong-kong-bay-5a12cd0038b90ebc671a7538a04b30d8.jpg";